import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  getAllAdvancedFilterRelatedApi,
  getAllReportData,
} from '../../store/actions';

import { FeatureWrapper, UnAuthorizedAccess } from '../../components';
import { APP_NAME } from '../../utils/constant';

import { ReportSelector } from './reportHome';

import './reports.scss';

class Reports extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async componentDidMount() {
    const { t, getAllReportData, getAllAdvancedFilterRelatedApi, user } =
      this.props;

    document.title = `${t('common.reports')} | ${APP_NAME}`;

    //ADVANCED FILTER RELATED DATA
    await Promise.all([
      getAllReportData(),
      getAllAdvancedFilterRelatedApi(user.organisation?.id),
    ]);
  }

  render() {
    return (
      <FeatureWrapper
        featureName="report"
        children={<ReportSelector {...this.props} />}
        fallbackComponent={<UnAuthorizedAccess />}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.authentication.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getAllReportData,
      getAllAdvancedFilterRelatedApi,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Reports));
